import { useState } from "react";
import type { FormEvent } from "react";
import { ApiError, ApiUnavailableError } from "@/api/client";
import { useAuth } from "@/hooks/useAuth";

export function SetupPage() {
  const { bootstrapAdmin } = useAuth();
  const [username, setUsername] = useState("");
  const [displayName, setDisplayName] = useState("");
  const [password, setPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [error, setError] = useState<string | null>(null);
  const [submitting, setSubmitting] = useState(false);

  async function handleSubmit(event: FormEvent) {
    event.preventDefault();
    setError(null);
    if (password !== confirmPassword) {
      setError("Passwords must match.");
      return;
    }
    setSubmitting(true);
    try {
      await bootstrapAdmin({
        username,
        display_name: displayName,
        password,
        device_name: "first-run-web",
      });
    } catch (err) {
      if (err instanceof ApiUnavailableError) {
        setError(err.message);
      } else if (err instanceof ApiError) {
        setError(err.problem.detail);
      } else {
        setError("Failed to create the first admin account.");
      }
    } finally {
      setSubmitting(false);
    }
  }

  return (
    <div className="login-page">
      <div className="login-card">
        <div className="login-brand">
          <span className="login-brand-mark-frame" aria-hidden="true">
            <img className="login-brand-mark" src="/knotfin-logo-v3.png" alt="" />
          </span>
          <h1 className="login-brand-title">Create Admin</h1>
        </div>
        <form onSubmit={handleSubmit}>
          {error && (
            <p className={`settings-status ${error.includes("API not responding") ? "settings-status--warning" : "settings-status--error"}`}>
              {error}
            </p>
          )}
          <label>
            Username
            <input
              type="text"
              value={username}
              onChange={(event) => setUsername(event.target.value)}
              autoComplete="username"
              required
            />
          </label>
          <label>
            Display Name
            <input
              type="text"
              value={displayName}
              onChange={(event) => setDisplayName(event.target.value)}
              autoComplete="name"
            />
          </label>
          <label>
            Password
            <input
              type="password"
              value={password}
              onChange={(event) => setPassword(event.target.value)}
              autoComplete="new-password"
              required
            />
          </label>
          <label>
            Confirm Password
            <input
              type="password"
              value={confirmPassword}
              onChange={(event) => setConfirmPassword(event.target.value)}
              autoComplete="new-password"
              required
            />
          </label>
          <button type="submit" disabled={submitting}>
            {submitting ? "Creating..." : "Create Admin"}
          </button>
        </form>
      </div>
    </div>
  );
}
